export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      className={`animate-pulse rounded-md bg-slate-200 ${className ?? "h-4 w-full"}`}
      aria-hidden
    />
  );
}
